(function ($) {
    "use strict";

    $(function () {
        $(".js-pm-text-image-slider").each(function () {
            var $slider = $(this);
            var $scope = $slider.closest(".pm-text-image__media-col");

            new Swiper(this, {
                slidesPerView: 1,
                speed: 400,
                observer: true,
                observeParents: true,
                grabCursor: true,
                mousewheel: {
                    forceToAxis: true,
                },
                navigation: {
                    nextEl: $scope.find(".js-pm-text-image-next")[0],
                    prevEl: $scope.find(".js-pm-text-image-prev")[0],
                },
                pagination: {
                    el: $scope.find(".js-pm-text-image-pagination")[0],
                    clickable: true,
                },
            });
        });
    });
})(jQuery);
